import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HierarchyAvailableLevelsPathParameters } from 'api/actions/hierarchy-available-levels/hierarchy-available-levels-path-parameters';
import { HierarchyAvailableLevelsResponse } from 'api/actions/hierarchy-available-levels/hierarchy-available-levels-response';

type HierarchyAvailableLevelsQueryParameters = Record<string, any>;

/**
 * The path of the HierarchyAvailableLevels action.
 */
export const hierarchyAvailableLevelsActionPath = new SweetPath<keyof HierarchyAvailableLevelsPathParameters>(
  '/api/hierarchy/available-levels',
  { path: '{param}' }
);

/**
 * Creates a contextualized HierarchyAvailableLevels actions.
 */
export default function createHierarchyAvailableLevelsAction(axios: AxiosInstance) {
  return function hierarchyAvailableLevelsAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: HierarchyAvailableLevelsQueryParameters } = {}) {
    const path = hierarchyAvailableLevelsActionPath.original;

    return axios.request<HierarchyAvailableLevelsResponse, HierarchyAvailableLevelsResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
